import { InvalidArgumentError } from '@commander-js/extra-typings';

export const validateFolderName = (value: string) => {
  const re = /^[a-z0-9][a-z0-9-]*$/;

  if (!re.test(value)) {
    throw new InvalidArgumentError(
      'The value must contain only lowercase letters, numbers, and hyphens.'
    );
  }

  return value;
};
